<script>
  import Button from "@components/Button.svelte"
  import Spinner from "@components/Spinner.svelte"

  export let processing = false
  export let disabled = false
</script>

<Button {...$$restProps} disabled={disabled || processing} submit>
  {#if processing}
    <Spinner />
    <span class="[ sr-only ]">Processing…</span>
  {:else}
    <slot />
  {/if}
</Button>
